import React from 'react';
import styles from './LayoutWrapper.module.css';
import { useSelector } from 'react-redux';
import classnames from 'classnames';

const LayoutWrapper = ({ children }) => {
  const isMenuPinned = useSelector((state) => state.user?.isMenuPinned);
  const isCertificationListPage = window.location.pathname.includes('ECMv6/certification/list');
  const isPreLaunchPage = window.location.pathname.includes('/campaign/prelaunch');

  // Pre-launch page has its own full-page layout — skip sidebar spacing
  if (isPreLaunchPage) {
    return <>{children}</>;
  }

  const classes = window.location.href?.includes('/login')
    ? styles.menuClosed
    : !isMenuPinned
    ? styles.menuClosed
    : isCertificationListPage
    ? styles.certificationListPage
    : styles.menuOpen

  const isNewSidebarClass = window.location.href?.includes('/login') ? '' : styles.sideBarSpacing;

  const className = classnames(
    classes,
    isNewSidebarClass,
    isNewSidebarClass && 'sideBarSpacing',
    isMenuPinned && 'Gen2NavMenuOpen',
  );

  return <div className={className}>{children}</div>;
};

export default LayoutWrapper;
